<template>
  <div class="mine">
    <div class="header">
      <van-image
        round
        width="1.5rem"
        height="1.5rem"
        :src="loginInfo.avatarUrl"
        error-icon="http://www.weopinions.com/images/photo/default.gif"
      />
      <div class="account-info">
        <div>{{ loginInfo.userName }}</div>
        <div>{{ $t("mine.xydj") }} {{ loginInfo.activityLevel }}</div>
      </div>
    </div>
    <div class="middle">
      <div class="left" @click="goToMyAccount(1)">
        {{ $t("mine.zhye") }} <span class="num">{{ loginInfo.balance }}</span>
        <van-icon name="ellipsis" />
      </div>
      <div class="right" @click="goToMyAccount(2)">
        {{ $t("mine.cxz") }} <span class="num">{{ loginInfo.credit }}</span>
        <van-icon name="ellipsis" />
      </div>
    </div>
    <div class="bottom">
      <div class="mine-wrap">
        <div
          class="mine-container"
          v-for="(itemCont, ind) of mineContent"
          :key="ind"
        >
          <div
            class="mine-box"
            v-for="item of itemCont"
            :key="item.randomId"
            @click="routeJump(item.routePath)"
          >
            <img :src="item.iconUrl" alt="item.label" class="mineIcon" />
            <span class="mineLabel">{{ item.label }}</span>
          </div>
        </div>
        <div
          class="mine-info-wrap"
          v-for="item of infoCont"
          :key="item.randomId"
          @click="routeJump(item.routePath)"
        >
          <span class="infoLabel">{{ item.label }}</span>
          <!--<span class="infoIcon"></span>-->
          <van-icon name="arrow" class="infoIcon" />
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button round block type="info" @click="logOut">{{
        $t("mine.tcdl")
      }}</van-button>
    </div>

    <van-dialog
      class="exchange-dialog"
      v-model="showDialog"
      :title="$t('mine.qrtc')"
      show-cancel-button
      @confirm="confirm"
      :cancel-button-text="$t('exchangePage.cancel')"
      :confirm-button-text="$t('exchangePage.confirm')"
    >
      <div>{{ $t("mine.tczh") }}</div>
    </van-dialog>
  </div>
</template>

<script>
import { accounts } from "@/api/api.js";
import { Notify } from "vant";
export default {
  name: "Mine",
  components: {},
  data() {
    return {
      showDialog: false,
      loginInfo: {},
      mineContent: {
        list1: [
          {
            randomId: Math.random(),
            label: this.$t("mine.qd"),
            iconUrl: require("@/assets/img/签到.png"),
            routePath: "/signIn",
          },
          {
            randomId: Math.random(),
            label: this.$t("mine.wdzl"),
            iconUrl: require("@/assets/img/我的资料.png"),
            routePath: "/myInfo",
          },
        ],
        list2: [
          {
            randomId: Math.random(),
            label: this.$t("mine.dhxx"),
            iconUrl: require("@/assets/img/兑换信息.png"),
            routePath: "/updateInfo",
          },
          {
            randomId: Math.random(),
            label: this.$t("mine.dtls"),
            iconUrl: require("@/assets/img/答题历史.png"),
            routePath: "/answerHistory",
          },
        ],
        list3: [
          {
            randomId: Math.random(),
            label: this.$t("mine.cjwt"),
            iconUrl: require("@/assets/img/常见问题.png"),
            routePath: "/offenQuestion",
          },
          {
            randomId: Math.random(),
            label: this.$t("mine.mmxg"),
            iconUrl: require("@/assets/img/密码修改.png"),
            routePath: "/changePwd",
          },
        ],
      },
      infoCont: [
        {
          randomId: Math.random(),
          label: this.$t("mine.yhxy"),
          routePath: "/privacyClauses/1",
        },
        {
          randomId: Math.random(),
          label: this.$t("mine.yctk"),
          routePath: "/privacyClauses/2",
        },
        {
          randomId: Math.random(),
          label: this.$t("mine.zxzh"),
          routePath: "/helpFeedback?type=contact",
        }
      ],
    };
  },
  methods: {
    logOut() {
      this.showDialog = true;
    },

    confirm() {
      setTimeout(() => {
        this.$router.replace("/");
        this.$store.commit("setAccountInfo", {});
        localStorage.clear();
      }, 1000);
    },
    goToMyAccount(flag) {
      this.$router.push({ path: "/myAccount", query: { title: flag } });
    },
    // 跳转
    routeJump(routePath) {
      this.$router.push({ path: routePath });
    },

    async initPage() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      if (JSON.stringify(this.$store.state.loginInfo) === "{}") {
        const params = {
          id: loginInfo.id,
        };
        await accounts(params).then((res) => {
          if (res.code === 200) {
            this.$store.commit("setAccountInfo", res.data);
            this.loginInfo = res.data;
          } else {
            Notify({ type: "danger", message: res.errors[0] });
          }
        });
      } else {
        this.loginInfo = this.$store.state.loginInfo;
      }
      this.getIsBlacklist();
    },
    getIsBlacklist() {
      if (this.loginInfo.isBlacklist) {
        this.$toast(
          `${this.$t("blacklistBefore")}${
            this.loginInfo.blacklistReason
          }${this.$t("blacklistAfter")}`
        );
      }
    },
  },
  mounted() {
    this.initPage();
    setTimeout(() => {
      if (
        localStorage.getItem("questionnaireItem") == 0 ||
        !localStorage.getItem("questionnaireItem")
      ) {
        localStorage.setItem("questionnaireItem", 1);
        //this.$router.go(0);
      }
    }, 100);
  },
  beforeDestroy() {
    // 判断是否是全屏显示
    console.log(12233);
    localStorage.setItem("questionnaireItem", 0);
  },
  activated() {},
};
</script>

<style lang="stylus" scoped>
/deep/.mine {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F3F3F3;

  .header {
    margin-top: 0.65rem;
    padding: 0.4rem;
    display: flex;
    align-items: center;
    font-weight: bold;

    .van-image__error-icon {
      font-size: 1.5rem;
    }

    .account-info {
      margin-left: 0.4rem;

      div:nth-child(2) {
        margin-top: 0.4rem;
      }
    }
  }

  .middle {
    padding: 0.2rem 0.4rem;
    display: flex;
    justify-content: space-around;

    div {
      border: 1px solid orange;
      width: 45%;
      height: 60px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      background: #FFFFFF;

      .num {
        color: orange;
      }

      .van-icon.van-icon-ellipsis {
        color: #C9C4C4;
        font-size: 0.4rem;
        font-weight: bold;
      }
    }
  }

  .bottom {
    padding: 0.4rem;

    .mine-wrap {
      padding: 0 0.45rem;
      background: #ffffff;
      border-radius: 0.2rem;

      .mine-container {
        height: 0.46rem;
        padding: 0.25rem 0;
        display: flex;
        border-bottom: 0.01rem solid rgba(187, 187, 187, 1);

        .mine-box {
          padding-left: 0.1rem;
          flex: 1;
          display: flex;
          align-items: center;

          .mineIcon {
            height: 100%;
          }

          .mineLabel {
            font-size: 0.28rem;
            line-height: 0.46rem;
            padding-left: 0.3rem;
          }
        }
      }

      .mine-info-wrap {
        width: 100%;
        height: 0.46rem;
        line-height: 0.46rem;
        padding: 0.25rem 0.1rem;
        border-bottom: 0.01rem solid rgba(187, 187, 187, 1);

        .infoLabel {
          font-size: 0.28rem;
        }

        .infoIcon {
          float: right;
          line-height: 0.46rem;
        }
      }

      .mine-info-wrap:last-child {
        border-bottom: none;
      }

      .mine-container:last-child {
        border-bottom: none;
      }
    }
  }

  .btn {
    width: 80%;
    height: 2.5rem;

    button {
      margin-left: 12.5%;
      background: #0056b5;
      border: #0056b5;
      font-size: 0.3rem;
      font-weight: 500;
    }
  }

  .exchange-dialog.van-dialog {
    .van-dialog__content {
      color: #9F9C9C;
      font-weight: bold;
      padding: 0.3rem;
      text-align: center;
    }

    .van-dialog__footer {
      .van-dialog__cancel {
        background: #97C1E2;
        color: #ffffff;
      }

      .van-dialog__confirm {
        background: #97C1E2;
        color: #FBC260;
      }

      .van-dialog__confirm:hover {
        background: #5376C2;
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mine/Mine.vue